import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'users/queries/shared/keys'
import goldStarsKeys from './shared/keys'
import { GoldStarsTransferParams } from './types'

type Variables = GoldStarsTransferParams

export function useTransferGoldStars(companyId: string | undefined) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: transferGoldStars,
    onSuccess: async () => {
      client
        .invalidateQueries({ queryKey: goldStarsKeys.all })
        .catch(() => null)
      client
        .invalidateQueries({ queryKey: keys.detail(companyId) })
        .catch(() => null)
    },
  })

  async function transferGoldStars(params: Variables): Promise<void> {
    if (!companyId) {
      throw new Error('Invalid company Id')
    }

    await server.post(`/v2/managers/me/goldstars/${companyId}/transfer`, {
      to_user_id: params.toUserId,
      star_count: params.starCount,
    })
  }
}
